import { useField } from 'formik'
import { useIntl } from 'react-intl'

import { QueuesAPI } from '@api/queuesAPI'

import { ID } from '@models/base'
import { Option } from '@models/option'

import { AsyncPaginateSelectField, AsyncPaginateSelectFieldProps } from '@components/Form/AsyncPaginateSelect'

type Props<IsMulti extends boolean> = Omit<AsyncPaginateSelectFieldProps<IsMulti>, 'onSearch'> & {
  exceptQueueId?: ID
}

const QueueSelectField = <IsMulti extends boolean = false>({ exceptQueueId, ...props }: Props<IsMulti>) => {
  const intl = useIntl()
  const [field, , helper] = useField<Option | Array<Option>>(props.name)
  const searchDebounce = async (keyword: string, page: number) => {
    const response = await QueuesAPI.getOptions({
      page: page,
      limit: 10,
      phrase: keyword ? keyword : undefined,
    })

    if (response?.data) {
      const defaultQueue = response.data.nodes.find((node) => node.is_default)

      if (defaultQueue && !field.value) {
        helper.setValue(Option.fromObject(defaultQueue, 'id', 'name'))
      }

      return {
        ...response.data,
        nodes: response.data.nodes
          .filter((node) => node.id !== exceptQueueId)
          .map(
            (queue) =>
              new Option({
                label: queue.name!,
                value: queue.id!,
              })
          ),
      }
    }
  }

  return (
    <AsyncPaginateSelectField
      {...props}
      onSearch={searchDebounce}
      noOptionsMessage={() => intl.formatMessage({ id: 'queue_node.not_found' })}
    />
  )
}

export default QueueSelectField
